import { useState } from "react";
import Reveal from "@/components/feature/Reveal";

interface GalleryProps {
  images: string[];
  name: string;
  videoUrl?: string;
  videoIndex?: number;
}

interface MediaItem {
  type: "image" | "video";
  src: string;
}

export default function Gallery({
  images,
  name,
  videoUrl,
  videoIndex = 3,
}: GalleryProps) {
  const [active, setActive] = useState<number | null>(null);

  const media: MediaItem[] = images.map((src) => ({ type: "image", src }));

  if (videoUrl) {
    media.splice(videoIndex, 0, { type: "video", src: videoUrl });
  }

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        {media.map((item, index) => (
          <Reveal key={`${item.type}-${item.src}`} delay={index * 60}>
            <button
              type="button"
              onClick={() => setActive(index)}
              className="group relative block w-full aspect-[4/3] overflow-hidden rounded-md"
            >
              {item.type === "image" ? (
                <img
                  src={item.src}
                  alt={`${name} - fotografía ${index + 1}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              ) : (
                <video
                  src={item.src}
                  muted
                  playsInline
                  preload="metadata"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              )}
              {item.type === "video" && (
                <span className="absolute top-2 right-2 rounded-full bg-foreground-950/60 backdrop-blur-sm text-background-50 text-[11px] font-medium px-2.5 py-1 whitespace-nowrap">
                  Video
                </span>
              )}
            </button>
          </Reveal>
        ))}
      </div>

      {active !== null && (
        <div
          className="fixed inset-0 z-[60] bg-foreground-950/90 flex items-center justify-center p-4 md:p-10"
          onClick={() => setActive(null)}
        >
          <button
            type="button"
            onClick={() => setActive(null)}
            aria-label="Cerrar galería"
            className="absolute top-5 right-5 w-11 h-11 flex items-center justify-center rounded-full bg-background-50/10 text-background-50 hover:bg-background-50/20 transition-colors"
          >
            <i className="ri-close-line text-2xl" />
          </button>
          {media[active].type === "image" ? (
            <img
              src={media[active].src}
              alt={`${name} - fotografía ampliada`}
              className="max-w-full max-h-full object-contain rounded-md"
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <video
              src={media[active].src}
              controls
              autoPlay
              playsInline
              className="max-w-full max-h-full rounded-md"
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </div>
      )}
    </>
  );
}